export default "__VITE_ASSET__271a508c__"